export interface RegionActivityData {
  region: string;
  value: number;
  percentage: number;
}

export interface TaskData {
  id: number;
  title: string;
  priority: 'high' | 'medium' | 'low';
  dueDate: string;
  completed: boolean;
}

export interface ActivityLogData {
  id: number;
  action: string;
  user: string;
  timestamp: string;
  type: 'user' | 'order' | 'payment' | 'flight' | 'support' | 'settings';
}

export interface NavigationItem {
  id: string;
  label: string;
  icon:
    | 'layoutDashboard'
    | 'users'
    | 'shoppingCart'
    | 'banknote'
    | 'handshake'
    | 'plane'
    | 'barChart3'
    | 'settings'
    | 'creditCard'
    | 'package'
    | 'receipt'
    | 'tag'
    | 'bell'
    | 'video'
    | 'shield'
    | 'gamepad'
    | 'clipboardList'
    | 'flame'
    | 'scrollText'
    | 'wallet'
    | 'smartphone'
    | 'image'
    | 'flaskConical'
    | 'userCheck';
  path: string;
  dividerType?: 'top' | 'bottom';
}

export interface CurrentUser {
  name: string;
  email: string;
  role: string;
  avatar: string | null;
}

export interface NotificationData {
  id: number;
  title: string;
  message: string;
  time: string;
  read: boolean;
}

// Activity heatmap data (regions)
export const regionActivityData: RegionActivityData[] = [
  { region: 'North America', value: 42, percentage: 35 },
  { region: 'Europe', value: 31, percentage: 26 },
  { region: 'Asia Pacific', value: 28, percentage: 23 },
  { region: 'South America', value: 12, percentage: 10 },
  { region: 'Africa', value: 7, percentage: 6 }
];

// Tasks/Events data
export const tasksData: TaskData[] = [
  { id: 1, title: 'Review new user applications', priority: 'high', dueDate: '2025-07-15', completed: false },
  { id: 2, title: 'Update pricing plans', priority: 'medium', dueDate: '2025-07-16', completed: false },
  { id: 3, title: 'Fix payment gateway issue', priority: 'high', dueDate: '2025-07-14', completed: true },
  { id: 4, title: 'Prepare monthly report', priority: 'low', dueDate: '2025-07-20', completed: false },
  { id: 5, title: 'Security audit review', priority: 'high', dueDate: '2025-07-18', completed: false }
];

// Activity log data
export const activityLogData: ActivityLogData[] = [
  { id: 1, action: 'New user registered', user: 'System', timestamp: '2 min ago', type: 'user' },
  { id: 2, action: 'Order #ORD-001 completed', user: 'Alex Johnson', timestamp: '15 min ago', type: 'order' },
  { id: 3, action: 'Payment received $524.00', user: 'James Wilson', timestamp: '32 min ago', type: 'payment' },
  { id: 4, action: 'Flight booking confirmed', user: 'Maria Garcia', timestamp: '1 hour ago', type: 'flight' },
  { id: 5, action: 'Support ticket resolved', user: 'Admin', timestamp: '2 hours ago', type: 'support' },
  { id: 6, action: 'New user registered', user: 'System', timestamp: '3 hours ago', type: 'user' },
  { id: 7, action: 'Settings updated', user: 'Admin', timestamp: '4 hours ago', type: 'settings' }
];

// Navigation items
export const navigationItems: NavigationItem[] = [
  { id: 'dashboard', label: 'Главная', icon: 'layoutDashboard', path: '/' },
  { id: 'users', label: 'Пользователи', icon: 'users', path: '/users', dividerType: 'top' },
  { id: 'duplicates', label: 'Дубли аккаунтов', icon: 'userCheck', path: '/duplicates' },
  { id: 'security', label: 'Безопасность', icon: 'shield', path: '/security' },
  { id: 'plans', label: 'Тарифы', icon: 'package', path: '/plans' , dividerType: 'top'},
  { id: 'experiment', label: 'Эксперимент', icon: 'flaskConical', path: '/experiment' },
  { id: 'videoLessons', label: 'Видеоуроки', icon: 'video', path: '/video-lessons' },
  { id: 'promoCodes', label: 'Промокоды', icon: 'tag', path: '/promo-codes' , dividerType: 'bottom'},
  { id: 'orders', label: 'Заказы', icon: 'shoppingCart', path: '/orders' },
  { id: 'payments', label: 'Платежи', icon: 'creditCard', path: '/payments' },
  { id: 'subscriptions', label: 'Подписки', icon: 'receipt', path: '/subscriptions', dividerType: 'bottom'},
  { id: 'notifications', label: 'Уведомления', icon: 'bell', path: '/notifications' },
  { id: 'banners', label: 'Баннеры', icon: 'image', path: '/banners' },
  { id: 'games', label: 'Игры', icon: 'gamepad', path: '/games', dividerType: 'top' },
  { id: 'examAttempts', label: 'Попытки экзаменов', icon: 'clipboardList', path: '/exam-attempts' },
  { id: 'wrongAnswers', label: 'Ошибки в ответах', icon: 'flame', path: '/wrong-answers' },
  { id: 'auditLog', label: 'Аудит-лог', icon: 'scrollText', path: '/audit-log', dividerType: 'top' },
  { id: 'cashflow', label: 'Cashflow', icon: 'banknote', path: '/cashflow' },
  { id: 'expenses', label: 'Расходы', icon: 'wallet', path: '/expenses' },
  { id: 'founders', label: 'Основатели', icon: 'handshake', path: '/founders' },
  { id: 'appConfig', label: 'Конфиг приложения', icon: 'smartphone', path: '/app-config', dividerType: 'top' },
  { id: 'settings', label: 'Настройки', icon: 'settings', path: '/settings' }
];

// Notifications
export const notificationsData: NotificationData[] = [
  { id: 1, title: 'New order received', message: 'Order #ORD-011 from Emily Clark', time: '5 min ago', read: false },
  { id: 2, title: 'Payment processed', message: 'Payment of $420.00 received', time: '20 min ago', read: false },
  { id: 3, title: 'System update', message: 'Dashboard updated to v2.1', time: '1 hour ago', read: true },
  { id: 4, title: 'New user signup', message: 'Michael Brown joined the platform', time: '2 hours ago', read: true }
];

